import React from 'react'
import moment from "moment";
import 'moment/locale/es';
import {  Transaction } from "../../models/interfaces";


function TransactionDetail(transaction: Transaction) {
    moment.locale('es');
    

    const commonStyle = {
        color: transaction.transaction_type_desc.toLowerCase() === "refund" ? 'red' : 'black',
      };
    
    return (
        <tr >
            <td style={ commonStyle} className='text-center'>{transaction.transaction_id} </td>
            <td style={ commonStyle} className='text-center'>{transaction.auth_code} </td>
            <td style={ commonStyle} className='text-end'>{getAmount(transaction)}</td>
            <td style={ commonStyle} className='text-center'>{ moment(transaction.date_time).format('DD/MM/YYYY HH:mm:ss')}</td> 
            <td style={ commonStyle}>{transaction.scheme.toUpperCase()}</td>
            <td style={ commonStyle}>{getCard(transaction.pan)}</td>
            <td style={ commonStyle}>{getTransactionType(transaction.transaction_type_desc)}</td> 
            <td style={ commonStyle} className='text-center'>{transaction.terminal_id} </td>
            <td style={ commonStyle}>{transaction.merchant_name}</td> 
            <td style={ commonStyle}>{transaction.full_name}</td> 
        </tr>
    );
  }

  
function getAmount(transaction: Transaction): React.ReactNode {
    let amount = transaction.amount;
    amount = amount / 100;
    return formatMoney(amount) + " " + transaction.currency_code;
}

function getTransactionType(transactionType: string){
  switch (transactionType) {
    case "PAYMENT":
      return "Pago"
      break;
    case "REFUND":
      return "Devolución"
      break;
    case "VOID":
        return "Anulación"
        break;
    default:
      return ""
      break;
  }
}

function getCard(pan: string){
  const parts = pan.split('*');
  return "********"+parts[parts.length - 1];
}

function formatMoney(amount) {
    const formatNumber = (number: number, decimalCount: number = 2, decimal: string = ",", thousands: string = ".") => {
        return number.toLocaleString(undefined, {
          minimumFractionDigits: decimalCount,
          maximumFractionDigits: decimalCount,
          useGrouping: true,
          currency: undefined,
          style: 'decimal',
        });
      };
      
      
      return formatNumber(amount);
  };

  
  export default TransactionDetail;